export var twitterConnected = {
  __typename: 'Twitter',
  authUrl: 'https://app.influitives.com/users/auth/twitter?origin=http%3A%2F%2Fhq.influitives.com%2Fprofiles%2F31e349a0-2be9-478f-9864-d5df8fb219b9&source=',
  connected: true,
  id: 'TWITTER',
  visible: false,
  profileUrl: 'https://www.twitter.com/123'
};
export var twitterDisconnected = {
  __typename: 'Twitter',
  authUrl: 'https://app.influitives.com/users/auth/twitter?origin=http%3A%2F%2Fhq.influitives.com%2Fprofiles%2F31e349a0-2be9-478f-9864-d5df8fb219b9&source=',
  connected: false,
  id: 'TWITTER',
  visible: true,
  profileUrl: 'https://www.twitter.com/123'
};
export var facebookConnected = {
  __typename: 'Facebook',
  authUrl: 'https://app.influitives.com/users/auth/facebook?origin=http%3A%2F%2Fhq.influitives.com%2Fprofiles%2F31e349a0-2be9-478f-9864-d5df8fb219b9&source=',
  connected: true,
  id: 'FACEBOOK',
  visible: true,
  profileUrl: 'https://www.facebook.com/123'
};
export var linkedinExpired = {
  __typename: 'Linkedin',
  authUrl: 'https://app.influitives.com/users/auth/linkedin?origin=http%3A%2F%2Fhq.influitives.com%2Fprofiles%2F31e349a0-2be9-478f-9864-d5df8fb219b9&source=',
  connected: true,
  id: 'LINKEDIN',
  visible: true,
  profileUrl: 'https://www.linkedin.com/123',
  expiresAt: '2010-10-12T07:20:50.52Z'
};
export var linkedinConnected = {
  __typename: 'Linkedin',
  authUrl: 'https://app.influitives.com/users/auth/linkedin?origin=http%3A%2F%2Fhq.influitives.com%2Fprofiles%2F31e349a0-2be9-478f-9864-d5df8fb219b9&source=',
  connected: true,
  id: 'LINKEDIN',
  visible: true,
  profileUrl: 'https://www.linkedin.com/123',
  expiresAt: '2040-10-12T07:20:50.52Z'
};
export var appleConnected = {
  __typename: 'Apple',
  authUrl: 'https://app.influitives.com/users/auth/twitter?origin=http%3A%2F%2Fhq.influitives.com%2Fprofiles%2F31e349a0-2be9-478f-9864-d5df8fb219b9&source=',
  connected: true,
  id: 'APPLE',
  visible: false
};
export var oauth2Disconnected = {
  __typename: 'OAuth2',
  authUrl: 'https://app.influitives.com/users/auth/twitter?origin=http%3A%2F%2Fhq.influitives.com%2Fprofiles%2F31e349a0-2be9-478f-9864-d5df8fb219b9&source=',
  connected: false,
  id: 'OAUTH2',
  visible: false,
  name: 'Dext'
};